import { render, staticRenderFns } from "./FileImportLicenseType.vue?vue&type=template&id=2bdfbc02&"
import script from "./FileImportLicenseType.vue?vue&type=script&lang=js&"
export * from "./FileImportLicenseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports